import { FC } from 'react';
import { SelfServiceAPI } from 'types';
import * as track from 'lib/gaTracking/crossPageEvents';

import ItemLinks from 'components/ItemLinks';
import compact from 'lodash/compact';

interface LinksProps {
  booking: SelfServiceAPI.Booking;
}

const Links: FC<LinksProps> = ({ booking }) => {
  const { isFinalising } = booking.flags;

  const rebookLink = {
    label: 'Book again',
    url: booking.links.rebook,
    external: true,
    onClick: track.bookAgainLink,
  };

  const printItineraryLink = !isFinalising && {
    label: 'Print itinerary',
    url: booking.links.print,
    external: false,
    target: '_blank',
    onClick: track.printItineraryLink,
  };

  return <ItemLinks links={compact([rebookLink, printItineraryLink])} height="100%" width="100%" />;
};

export default Links;
